import { TabContext, TabPanel } from "@mui/lab";
import { TabLinks } from "components/TabLinks";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { useSearchParams } from "react-router-dom";

import { PipelineRuns } from "./PipelineRuns";
import { VendorData } from "./VendorData";
import { WasteVendors } from "./WasteVendors";

const PIPELINE_RUNS_TAB = ".?tab=pipeline-runs";
const WASTE_VENDORS_TAB = ".?tab=waste-vendors";
const VENDOR_DATA_TAB = ".?tab=vendor-data";

export function PipelinesTabs() {
  useBreadcrumb({ label: "Pipelines" });

  const [searchParams] = useSearchParams();

  const tabs = [
    {
      title: "Pipeline Runs",
      to: PIPELINE_RUNS_TAB,
      component: <PipelineRuns />,
    },
    {
      title: "Waste Vendors",
      to: WASTE_VENDORS_TAB,
      component: <WasteVendors />,
    },
    {
      title: "Vendor Data",
      to: VENDOR_DATA_TAB,
      component: <VendorData />,
    },
  ];

  const selectedTabVal =
    tabs.find((t) => t.to === `.?tab=${searchParams.get("tab")}`)?.to ?? tabs[0].to;

  return (
    <TabContext value={selectedTabVal}>
      <TabLinks tabs={tabs} value={selectedTabVal} />
      {tabs.map((tab) => (
        <TabPanel key={tab.to} value={tab.to} sx={{ px: 0 }}>
          {tab.component}
        </TabPanel>
      ))}
    </TabContext>
  );
}
